import axiosClient from "./axiosClient";

const AgentModel = {
    // Lấy danh sách đại lý
    getAll: () => {
        return axiosClient.get('/api/agents');
    },
    
    // Lấy chi tiết đại lý
    getById: (id) => {
        return axiosClient.get(`/api/agents/${id}`);
    },
    
    // Tạo đại lý mới
    create: (data) => {
        return axiosClient.post('/api/agents', data);
    },
    
    // Cập nhật đại lý
    update: (id, data) => {
        return axiosClient.put(`/api/agents/${id}`, data);
    },
    
    // Xóa đại lý
    delete: (id) => {
        return axiosClient.delete(`/api/agents/${id}`);
    },
    
    // Nạp tiền cho đại lý
    addBalance: (id, amount) => {
        return axiosClient.post(`/api/agents/${id}/add-balance`, { amount });
    },
    
    // Lấy danh sách users có thể làm đại lý
    getAvailableUsers: () => {
        return axiosClient.get('/api/agents/available-users');
    }
};

export default AgentModel;
